// RecentActivity.jsx - Recent activity feed
import React from 'react';
import { Card, List, Avatar, Tag, Typography, Space } from 'antd';
import { 
  ClockCircleOutlined,
  FileTextOutlined,
  CodeOutlined,
  FormatPainterOutlined ,
  TrophyOutlined,
  UserOutlined
} from '@ant-design/icons';

const { Text } = Typography;

const RecentActivity = () => {
  // Mock activity data - replace with real data
  const activities = [
    {
      id: 1,
      type: 'blog',
      action: 'Published new blog post',
      title: 'Getting Started with React Hooks',
      time: '2 hours ago',
      icon: <FileTextOutlined />,
      color: 'blue'
    },
    {
      id: 2,
      type: 'project',
      action: 'Updated development project',
      title: 'Portfolio Website v2.0',
      time: '5 hours ago',
      icon: <CodeOutlined />,
      color: 'green'
    },
    {
      id: 3,
      type: 'design',
      action: 'Added new design project',
      title: 'Mobile App UI Design',
      time: '1 day ago',
      icon: <FormatPainterOutlined />,
      color: 'orange'
    },
    {
      id: 4,
      type: 'cert',
      action: 'Earned new certification',
      title: 'AWS Solutions Architect',
      time: '2 days ago',
      icon: <TrophyOutlined />,
      color: 'purple'
    },
    {
      id: 5,
      type: 'profile',
      action: 'Updated profile information',
      title: 'Added new skills',
      time: '3 days ago',
      icon: <UserOutlined />,
      color: 'cyan'
    }
  ];

  return (
    <Card 
      title={
        <div className="flex items-center space-x-2">
          <ClockCircleOutlined className="text-accent-blue" />
          <span>Recent Activity</span>
        </div>
      }
      className="shadow-medium border border-border-light rounded-xl h-full"
    >
      <List
        dataSource={activities}
        renderItem={(item) => (
          <List.Item className="hover:bg-bg-secondary rounded-lg px-3 py-2 transition-colors">
            <List.Item.Meta
              avatar={
                <Avatar 
                  icon={item.icon}
                  className={`bg-${item.color}-100 text-${item.color}-600`}
                />
              }
              title={
                <div className="flex items-center justify-between">
                  <Text className="text-text-primary font-medium">
                    {item.action}
                  </Text>
                  <Text className="text-text-secondary text-xs">
                    {item.time}
                  </Text>
                </div>
              }
              description={
                <Space>
                  <Text className="text-text-secondary">{item.title}</Text>
                  <Tag color={item.color} size="small">
                    {item.type}
                  </Tag>
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default RecentActivity;